"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette, _theme$customTypograp, _theme$palette2, _theme$palette3, _theme$palette4, _theme$palette5;
  return {
    navRoot: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      "& ul": {
        listStyle: "none"
      }
    },
    firstLayer: {
      alignItems: "center",
      borderBottom: "1px solid",
      borderBottomColor: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[300],
      color: "inherit",
      display: "flex",
      ...(theme === null || theme === void 0 || (_theme$customTypograp = theme.customTypography) === null || _theme$customTypograp === void 0 || (_theme$customTypograp = _theme$customTypograp.menu) === null || _theme$customTypograp === void 0 ? void 0 : _theme$customTypograp.firstLayer),
      minHeight: 48,
      padding: theme.spacing(1.5, 2),
      position: "relative",
      "&:hover": {
        background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.grey) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2[200]
      }
    },
    firstLayerSelected: {
      background: (0, _styles.alpha)((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.primary) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.main, 0.1),
      "&:before": {
        background: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 || (_theme$palette4 = _theme$palette4.primary) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.main,
        bottom: "0",
        content: "''",
        display: "block",
        left: "0",
        position: "absolute",
        top: "0",
        width: 4
      },
      "&:hover": {
        background: (0, _styles.alpha)((_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 || (_theme$palette5 = _theme$palette5.primary) === null || _theme$palette5 === void 0 ? void 0 : _theme$palette5.main, 0.1)
      }
    },
    icon: {
      minWidth: 40
    }
  };
});
const MenuList = _ref => {
  let {
    data
  } = _ref;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("nav", {
    className: css.navRoot
  }, /*#__PURE__*/_react.default.createElement("ul", null, data.items.map(item => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(FirstLayer, {
      itemData: item
    }));
  }))));
};
const FirstLayer = _ref2 => {
  let {
    itemData
  } = _ref2;
  const [subVisible, setSubVisible] = (0, _react.useState)(itemData.selected);
  return /*#__PURE__*/_react.default.createElement(Reference, {
    itemData: itemData,
    currentVisible: subVisible,
    toggleVisible: setSubVisible
  });
};
const Reference = _ref3 => {
  let {
    currentVisible,
    itemData,
    layer = "first",
    toggleVisible
  } = _ref3;
  const {
    link,
    selected,
    icon,
    title,
    items: subItems,
    target
  } = itemData;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  let svg = null;
  if (icon && icon.filename) {
    svg = /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.icon,
      src: REACT_APP_PATH + icon.filename,
      wrapper: "span",
      size: 24
    });
  }
  if (link.indexOf("http://") > -1 || link.indexOf("https://") > -1) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: link,
      className: css["".concat(layer, "Layer")],
      target: target !== "_top" ? target : null,
      rel: "noopener noreferrer"
    }, svg, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: link,
    className: (0, _clsx.default)({
      [css["".concat(layer, "Layer")]]: true,
      [css["".concat(layer, "LayerSelected")]]: selected
    }),
    onClick: e => {
      if (subItems) {
        e.preventDefault();
        toggleVisible(!currentVisible);
      }
    }
  }, svg, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }));
};
var _default = exports.default = MenuList;